import React from 'react';
import {
  Badge,
  Button,
  Icon,
  Paper,
  Tooltip
} from '@material-ui/core';
import { CTA } from './utils/helperData';


const CustomToolbar = ({
  setOpenFilter,
  activeCTA,
  setActiveCTA
}) => {
  return (
    <Paper className="px-5 py-3 w-full elevation-z0">
      <div className="flex items-center w-full justify-evenly">
        {CTA.map((cta) => (
          <Button
            fullWidth
            key={cta.value}
            variant={cta.value === activeCTA ? 'contained' : 'outlined'}
            color="primary"
            className="mr-2"
            onClick={() => setActiveCTA(cta.value)}
          >
            {cta.label}
          </Button>
        ))}
        <Badge
          badgeContent={0}
          color="primary"
          overlap="rectangular"
        >
          <Tooltip title="Filter by">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenFilter(true)}
            >
              <Icon className="mr-2 text-primary">
                filter_list
              </Icon>
              <span className="text-brand">Filter Data</span>
            </Button>
          </Tooltip>
        </Badge>
      </div>
    </Paper>
  );
};

export default CustomToolbar;
